
import { LayoutBase } from '../../layouts';
import { ToolsDetails } from '../../components/custom';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Icon, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useAuthContext } from '../../context';
import { ILegislation, LegislationService } from '../../services/api/legislation/Legislation';
import { useEffect, useState } from 'react';

export const Legislation = () => {

    const navigate = useNavigate();
    const { userData } = useAuthContext();
    const [ data, setData ] = useState<ILegislation[]>([]);

    const handleNew = () => {
        navigate('./novo');
    };

    useEffect(() => {
        fetchData();
    },[]);

    const fetchData = () => {
        LegislationService.list()
            .then((response) => {
                if(response instanceof Error){
                    console.log(response.message);
                }else{
                    setData(response);
                }
            });
    };

    const handleDelet = (uuid: string) => {
        LegislationService.delet(uuid)
            .then((response) => {
                if(response instanceof Error){
                    console.log(response.message);
                }else{
                   console.log('ok');
                }
            });
    };
    
    return(
        <LayoutBase title='Legislação'
            tollBar={
                <ToolsDetails
                    onClickNew={handleNew}
                    showDeletButton={false}
                    showSaveButton={false}
                    showNewButton={userData.nivel == 'adm' ? true : false}
                />
            }
        >
            {data === undefined ? <LinearProgress/> : 
            <Box padding={2}>
                <TableContainer component={Paper} variant='outlined' sx={{borderRadius: '25px'}} >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center'><Typography><strong>Nome</strong></Typography></TableCell>
                                <TableCell align='center'><Typography><strong>Descrição</strong></Typography></TableCell>
                                <TableCell align='center'><Typography><strong>Orgão</strong></Typography></TableCell>
                                {userData.nivel == 'adm' ? <TableCell align='center'><Typography><strong>Ações</strong></Typography></TableCell> : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((item, index) => 
                                <TableRow key={index}>
                                    <TableCell align='center'>{item.nome}</TableCell>
                                    <TableCell align='center'>{item.descricao}</TableCell>
                                    <TableCell align='center'>{item.orgaoLegislador}</TableCell>
                                    {userData.nivel === 'adm' ? 
                                        <TableCell align='center'>
                                            <Box
                                                display={'flex'}
                                                flexDirection={'column'}
                                                >
                                                
                                                <IconButton size='small' onClick={()=> navigate(`./${item.uuid}`)}>
                                                    <Icon color='primary'>edit</Icon>
                                                </IconButton>
                                                {/* <Button
                                                    startIcon={<Remove/>}
                                                    color={'error'}
                                                    onClick={() => handleDelet(item.uuid)}
                                                >Remover</Button> */}
                                            </Box>
                                        </TableCell>
                                        : null
                                        // <TableCell>
                                        //     <Box
                                        //         display={'flex'}
                                        //         flexDirection={'column'}
                                        //     >
                                        //         <Button
                                        //             startIcon={<Edit/>}
                                        //             color={'info'}
                                        //             >Dowload</Button>
                                        //     </Box>
                                        // </TableCell>
                                    }
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            }
        </LayoutBase>
    );
};